import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import MainLayout from 'layouts/MainLayout'
import EnhancementPage from 'pages/EnhancementPage'
import GenerationPage from 'pages/GenerationPage'
import SettingsPage from 'pages/SettingsPage'
import DocumentPage from 'pages/DocumentPage'
import WebviewPage from 'pages/WebviewPage'
import HistoryPage from 'pages/HistoryPage'
import NoMatchPage from 'pages/NoMatchPage'
import SettingsList from 'components/SettingsList'
import LanguageChange from 'components/LanguageChange'
import TermsOfUse from 'components/documents/TermsOfUse'
import PrivacyPolicy from 'components/documents/PrivacyPolicy'

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<MainLayout />}>
          <Route index element={<EnhancementPage />} />
          <Route path="neuro-art" element={<GenerationPage />} />
          <Route path="settings" element={<SettingsPage />}>
            <Route index element={<SettingsList />} />
            <Route path="language" element={<LanguageChange />} />
          </Route>
          <Route
            path="terms-of-use"
            element={<DocumentPage document={<TermsOfUse />} />}
          />
          <Route
            path="privacy-policy"
            element={<DocumentPage document={<PrivacyPolicy />} />}
          />
          <Route path="history/:requestId" element={<HistoryPage />} />
          <Route path="*" element={<NoMatchPage />} />
        </Route>
        <Route path="/webview" element={<WebviewPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Router
